const INDEX_ITEMS = [
  { icon: 'ri-sword-line', title: '国产古装精选', desc: '热门古装大剧全集', color: 'primary' },
  { icon: 'ri-heart-pulse-line', title: '韩剧高分推荐', desc: '口碑韩剧一次看全', color: 'accent' },
  { icon: 'ri-search-eye-line', title: '悬疑烧脑合集', desc: '高能反转烧脑佳作', color: 'secondary' },
  { icon: 'ri-heart-line', title: '甜宠爱情剧场', desc: '甜蜜浪漫心动之选', color: 'primary' },
  { icon: 'ri-building-line', title: '都市情感热播', desc: '都市生活情感大戏', color: 'accent' },
  { icon: 'ri-restart-line', title: '经典重温专区', desc: '经典好剧值得再看', color: 'secondary' },
  { icon: 'ri-sparkling-line', title: '最新完结好剧', desc: '刚完结的热门全集', color: 'primary' },
];

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-500', border: 'hover:border-primary-200' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-500', border: 'hover:border-accent-200' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-500', border: 'hover:border-secondary-200' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">专题合集</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            按类型和主题分类，快速找到你想看的电视剧全集
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
          {INDEX_ITEMS.map((item) => {
            const c = colorMap[item.color];
            return (
              <div
                key={item.title}
                className={`flex flex-col items-center gap-3 p-5 bg-background-50 rounded-lg border border-background-200/70 ${c.border} transition-colors cursor-pointer text-center`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${c.bg}`}>
                  <i className={`${item.icon} text-xl ${c.text}`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-foreground-900 text-sm whitespace-nowrap">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}